import CGallery from "core/components/CGallery";
import { ITEMS, ITEMS_2, ITEMS_3 } from "core/components/CGallery/exampleData";
import Comment from "modules/Community/components/comment";

const CommonPhase4 = () => {
  return (
    <div>
      <h1>CommonPhase4</h1>
      <CGallery className="p-4" items={ITEMS} />
      <CGallery className="p-4" items={ITEMS_2} />
      <CGallery className="p-4" items={ITEMS_3} />
      <Comment className="p-4" />
    </div>
  );
}

export default CommonPhase4;
